"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractValidationValues = exports.validateForm = exports._devMode = void 0;
exports._devMode = process.env.NODE_ENV !== "production";
function validateForm(input, config = {
    enabled: true,
    validationConfig: {},
    initialValues: undefined,
}) {
    const { enabled, validationConfig, initialValues } = config;
    const errors = {};
    if (enabled !== undefined && !enabled)
        return { errors, isValid: false };
    Object.entries(Object.assign(Object.assign({}, extractValidationValues(initialValues !== null && initialValues !== void 0 ? initialValues : input)), validationConfig)).forEach(([key, value]) => {
        var _a;
        const { name, required, type, charLength, dependOn, isEqualTo } = (_a = value) !== null && _a !== void 0 ? _a : {};
        if (value)
            if (dependOn) {
                const { key: dependOnKey, value: dependOnValue } = dependOn;
                const charArray = Array.isArray(dependOnValue) ? [...dependOnValue] : [dependOnValue];
                if (input && charArray.includes(input[dependOnKey]) && (!input[key] || isEmptyValue(input[key]))) {
                    errors[key] = `${key.replace(/_/g, " ")} is required`;
                }
            }
            else if (isEqualTo) {
                const { key: isEqualToKey, value: isEqualToValue } = isEqualTo;
                const charArray = Array.isArray(isEqualToValue) ? [...isEqualToValue] : [isEqualToValue];
                if (input && charArray.includes(input[isEqualToKey]) && input[isEqualToKey] !== input[key]) {
                    errors[key] = `${isEqualToKey.replace(/_/g, " ")}(s) do not match`;
                }
            }
            else if (required) {
                if ((input && isEmptyValue(input[key])) || input === null) {
                    errors[key] = `${name || key.replace(/_/g, " ")} is required`;
                }
                else if ((key === "email" || type === "emailAddress") && !validateEmail(input[key])) {
                    errors[key] = `${name || key.replace(/_/g, " ")} must be a valid email address`;
                }
                else if ((key === "phone" || key == "contact_number" || type === "phoneNumber") && !validatePhone(input[key])) {
                    errors[key] = `${name || key.replace(/_/g, " ")} must be a 10-digit phone number`;
                }
                else if (charLength && input[key].length > charLength) {
                    errors[key] = `${name || key.replace(/_/g, " ")} must not be more than ${charLength}`;
                }
                else if (type === "number") {
                    errors[key] = `${name || key.replace(/_/g, " ")} must be a number`;
                }
                else if (type === "url" && !validateUrl(input[key])) {
                    errors[key] = `${name || key.replace(/_/g, " ")} must not include http:\// or https:\//`;
                }
                // --- add conditions for "date" | "text"
            }
            else
                return;
    });
    const isValid = Object.keys(errors).length === 0;
    return { errors, isValid };
}
exports.validateForm = validateForm;
function isEmptyValue(value) {
    const isObject = typeof value === "object";
    return value === "" || value === null || (Array.isArray(value) && value.length === 0) || (isObject && Object.keys(value).length === 0);
}
function validateUrl(url) {
    // url validation regex
    const regex = /^((https?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!$&'()*+,;=]*)$/;
    return regex.test(url);
}
function validateEmail(email) {
    // email validation regex
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return regex.test(email);
}
function validatePhone(phone) {
    // phone number validation regex
    const regex = /^\d{10}$/;
    return regex.test(phone);
}
function extractValidationValues(initialData) {
    return Object.keys(initialData !== null && initialData !== void 0 ? initialData : {}).reduce((result, key) => {
        return Object.assign(Object.assign({}, result), { [key]: { required: true } });
    }, {});
}
exports.extractValidationValues = extractValidationValues;
